<template>
  <main-layout
    class="insurance"
    :page-title="title"
    custom-back
    @listen-back="goBacklist"
  >
    <div slot="main-content" class="main-content">
      <component :is="currentStep"> </component>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import IntroducedDetails from "@/views/ruralInsurance/ruralDeatils/Index.vue";
import OrderDetails from "@/views/ruralInsurance/OrderDetails/Index.vue";
import { setStorage, getStorage, removeStorage } from "@/utils/storage";

export default {
  name: "DetailsIndex",
  components: { MainLayout, OrderDetails, IntroducedDetails },
  data() {
    return {
      // 判断来的路径
      pathWhere: getStorage("pathWhere") ? getStorage("pathWhere") : "",
      currentStep:
        getStorage("detailsType") && getStorage("detailsType").currentStep
          ? getStorage("detailsType").currentStep
          : "IntroducedDetails",
      title:
        getStorage("detailsType") && getStorage("detailsType").title
          ? getStorage("detailsType").title
          : "保单详情",
    };
  },

  created() {
    if (this.$route.query.type === 1) {
      setStorage("detailsType", {
        title: "保单详情",
        currentStep: "IntroducedDetails",
      });
      this.title = getStorage("detailsType").title;
      this.currentStep = getStorage("detailsType").currentStep;
    } else if (this.$route.query.type === 2) {
      setStorage("detailsType", {
        title: "意向单详情",
        currentStep: "OrderDetails",
      });
      this.title = getStorage("detailsType").title;
      this.currentStep = getStorage("detailsType").currentStep;
    }
  },
  destroyed() {
    removeStorage("pathWhere");
  },
  methods: {
    goBacklist() {
      window.history.go(-1);
      // if (this.pathWhere === "/ruralWriteInfo") {
      //   this.$router.push({
      //     name: "InsuranceList",
      //     params: {
      //       id: 1,
      //     },
      //   });
      // } else {
      //   window.history.go(-1);
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;
  }
}

::v-deep .common-page-header .title {
  font-size: 22px !important;
}
</style>
